import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class ItemListPanelConstants {
  //Checklist Setup
  CCIitemType = "CCI";
  eBuiltItemType = "eBuilt";
  AOCrequiredItemType = "AOCQBuiltStandard";
  AOCoptionalItemType = "AOCFacilityOptional";

  requiredItem = "Required";
  optionalItem = "Optional";

  //Required Items Panel
  requiredPanelTitle = "Select Required Department";
  requiredWarningTooltip = "All required items must be added to your checklist before moving onto the next section";
  emptyTextSidePanel = "Select a Department to begin adding items";
  emptyTextSetupPanel = "Create Stations and Drag Required Items into your Stations to Configure Checklist";
  emptyDropZoneText = "Drag Items Here to Populate Your Stations";
  //Optional Items Panel
  optionalPanelTitle = "Optional Items";
  //Save Panel
  //Dialog Popup - Add Station
  addStationButtonText: string = "Add Station";
  dialogAddTitle: string = "Add Station";
  dialogCancelButtonText: string = "Cancel";
  dialogAddConfirmButtonText: string = "Add";
  dialogAddHasInput: boolean = true;
  dialogInputTitle: string = "Station Name:";
  dialogInputPlaceholder: string = "Enter Station Name...";
  dialogInputValue: string = "";
  //Dialog Popup - Edit Station
  editStationButtonText: string = "Edit Station";
  dialogEditTitle: string = "Edit Station";
  dialogEditConfirmButtonText: string = "Save";
  //Dialog Popup - Task Duration
  dialogDurationTitle: string = "Task Duration";
  dialogDurationMessage: string = "After chosen date passes, the item will be automatically removed from all new inspection forms moving forward.";
  dialogDurationDatePickerLabel: string = "Select Date Range";

  //Facility Configuration
  fcPanelTitle: string = "Stations";
  fcWarningTooltip: string = "All stations must be assigned to a Zone before you can save your Facility Configuration";
  fcEmptyZone: string = "Create Zones and Drag Stations into Zones to Configure Facility";
  fcAddZoneButtonText: string = "Add Zone";

}